import $ from 'jquery';

let didScroll = false;
let lastScrollTop = 0;

setInterval(function () {
	if (didScroll) {
		hasScrolled();
		didScroll = false;
	}
}, 300);

$(window).on('scroll', (e) => {
	didScroll = true;
});

$('.site-header .solverre-birds').on('mouseenter', () => {
	$('.site-header .solverre-birds .description').addClass('active');
	console.log('mouse enter');
});

$('.site-header .solverre-birds').on('mouseleave', () => {
	$('.site-header .solverre-birds .description').removeClass('active');
});

$('.site-header .solverre-birds').on('click', () => {
	window.location.href = '/';
});

$('.site-header .menu-button').on('click', () => {
	$(this).toggleClass('active');

	if ($('.site-header .nav-2').hasClass('active')) {
		$('.site-header .nav-1').removeClass('nav-2-active');
		$('.site-header .nav-2').removeClass('active');
	} else {
		$('.site-header .nav-1').addClass('nav-2-active');
		$('.site-header .nav-2').addClass('active');
	}
});

function hasScrolled() {
	let scrollTolerance = 80;
	let thisScrollTop = $(window).scrollTop();
	let scrollDelta = Math.abs(lastScrollTop - thisScrollTop);
	let scrollDirection = thisScrollTop - lastScrollTop;

	if (scrollDelta > scrollTolerance) {
		let header = $('header.wp-block-template-part');

		if (scrollDirection > 0) {
			header.addClass('birds');
		} else {
			header.removeClass('birds');
		}
		lastScrollTop = thisScrollTop;
	}
}
